import { lazy, Suspense } from 'react';

import { ShippingInfoDialogProps } from './types';

// Loaded on first use from the list's row menu ("Update shipping info").
const ShippingInfoDialogInner = lazy(() =>
  import('./index').then((module) => ({
    default: module.ShippingInfoDialog,
  }))
);

export const LazyShippingInfoDialog = (props: ShippingInfoDialogProps) => (
  <Suspense fallback={null}>
    <ShippingInfoDialogInner {...props} />
  </Suspense>
);

// The details page's "Edit LTL" on a Done stock order, loaded on demand.
const StockOrderShippingLtlEditInner = lazy(() =>
  import('./index').then((module) => ({
    default: module.StockOrderShippingLtlEdit,
  }))
);

export const LazyStockOrderShippingLtlEdit = (props: { id: number }) => (
  <Suspense fallback={null}>
    <StockOrderShippingLtlEditInner {...props} />
  </Suspense>
);
